export const SHOW_HIDE_WARNING = 'SHOW_HIDE_WARNING';
